import { useSyncUserLmsEnrollments } from '@actions';
import Button from '@components/V4/Button';
import useToast from 'apps/agora/src/hooks/useToast';

interface SyncLmsEnrollmentsButtonProps {
  userId?: string;
  className?: string;
}

const SyncLmsEnrollmentsButton = (props: SyncLmsEnrollmentsButtonProps) => {
  const { userId, className } = props;

  const toast = useToast();

  const { mutate: syncLmsEnrollments, isLoading } = useSyncUserLmsEnrollments(userId ?? '', {
    onSuccess: (data) => {
      if (!data.totalCourses) {
        toast.info('This user has no active enrollments, so there is nothing to sync.');
        return;
      }

      const parts = [`${data.enrolled.length} added`];

      if (data.alreadyEnrolled.length) {
        parts.push(`${data.alreadyEnrolled.length} already there`);
      }

      if (data.skipped.length) {
        parts.push(`${data.skipped.length} without an LMS course`);
      }

      if (data.failed.length) {
        toast.error(
          `${parts.join(', ')}. Failed: ${data.failed.map((item) => item.course).join(', ')}.`
        );
        return;
      }

      toast.success(`LMS synced: ${parts.join(', ')}.`);
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.error?.message ?? 'The LMS courses could not be synced.');
    },
  });

  return (
    <Button
      variant="secondary"
      className={className}
      isLoading={isLoading}
      disabled={!userId}
      buttonText={isLoading ? 'Syncing LMS...' : 'Sync LMS courses'}
      onClick={() => syncLmsEnrollments({})}
    />
  );
};

export default SyncLmsEnrollmentsButton;
